import React, { useState, useMemo } from 'react';
import css from './FilterSidebar.module.css';
import FilterSectionHeader from './FilterSectionHeader';
import SearchInput from './SearchInput';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

const SHORT_TALENT_COUNT = 3;

const TypeOfTalentFilterSection = ({
  talentTypes = [],
  handleClearFilter,
  handleCheckboxChange,
  handleToggleTalentType,
  paramKey,
  isBlackBgFilter,
  selectedValues = [],
  isTalentOfferingFilters,
}) => {
  const { formatMessage } = useIntl();
  const [searchTerm, setSearchTerm] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);

  // Memoized filtering for performance
  const filteredTalentTypes = useMemo(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    return talentTypes.filter(({ value }) => value.toLowerCase().includes(lowerSearchTerm));
  }, [searchTerm, talentTypes]);

  // Determine how many items to display based on toggle state
  const displayedTalentTypes = isExpanded
    ? filteredTalentTypes // Show all when expanded
    : filteredTalentTypes.slice(0, SHORT_TALENT_COUNT); // Show only 5 when collapsed

  const handleClear = () => {
    handleClearFilter(paramKey);
    setSearchTerm('');
  };

  const handleTalentTypeSearch = e => {
    setSearchTerm(e.target.value);
    setIsExpanded(false); // Reset to collapsed state when searching
  };

  const toggleExpand = () => {
    setIsExpanded(prev => !prev); // Toggle the expanded state
    if (handleToggleTalentType) {
      handleToggleTalentType(); // Call the prop if provided
    }
  };

  // Dynamically set the button label based on the toggle state
  const buttonLabel = isExpanded
    ? formatMessage({ id: 'FilterCategories.showLess' })
    : formatMessage({ id: 'FilterCategories.showMore' });

  return (
    <div
      className={classNames(
        css.filterSection,
        isTalentOfferingFilters ? css.talentOfferingFilters : null
      )}
    >
      {!isTalentOfferingFilters && (
        <FilterSectionHeader
          isBlackBgFilter={isBlackBgFilter}
          titleId={'FilterCategories.typeOfTalent'}
          handleClear={handleClear}
        />
      )}
      <SearchInput
        type="text"
        className={css.searchInput}
        placeholder="Search Type of talent..."
        value={searchTerm}
        onChange={handleTalentTypeSearch} // Pass the event directly
      />

      <div className={css.scrollable}>
        {displayedTalentTypes.map(({ value, label }) => {
          const isChecked = selectedValues.includes(value.toLowerCase());

          return (
            <label key={value} className={css.checkboxLabel}>
              <input
                type="checkbox"
                value={value}
                checked={isChecked}
                onChange={e => handleCheckboxChange(e, paramKey)}
              />
              <span>{label}</span>
            </label>
          );
        })}
      </div>

      {filteredTalentTypes.length > SHORT_TALENT_COUNT && (
        <button className={css.moreButton} onClick={toggleExpand}>
          {buttonLabel}
        </button>
      )}
    </div>
  );
};

export default TypeOfTalentFilterSection;
